import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { io } from "socket.io-client";
import {
  fetchPaymentLinks,
  fetchGuestById,
  invitationSubmit,
  fetchAnswerAvailability,
  fetchSmoothReception,
} from "../../Service";
import {
  Button,
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  Stack,
  Container,
  DialogTitle,
} from "@mui/material";

import Cover from "./componetns/Cover";
import Greeting from "./componetns/Greeting";
import Introduction from "./componetns/Introduction";
import OurStory from "./componetns/OurStory";
import Information from "./componetns/Information";
import InvitationForm from "./componetns/InvitationForm";
import GuestMenu from "./componetns/GuestMenu";
import PersonalProfile from "./componetns/PersonalProfile";
import Sending from "./componetns/Sending";
import "./componetns/css/sending.css";
import theme from "./theme";

import Loading from "./componetns/Loading";

const API_URL = process.env.REACT_APP_API_URL;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const Invitation = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [paymentLinks, setPaymentLinks] = useState([]);
  const [guests, setGuests] = useState([]);
  const [leader, setLeader] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const [appbarHeight, setAppbarHeight] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showHeader, setShowHeader] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [sendingLoading, setSendingLoading] = useState(false);
  const [smoothStatus, setSmoothStatus] = useState(null);
  const [smoothLoaded, setSmoothLoaded] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [sendComp, setSendComp] = useState(false);
  const [receptedDialog, setReceptedDialog] = useState(false);

  const tref1 = useRef(null);
  const tref2 = useRef(null);
  const [tourOpen, setTourOpen] = useState(false);
  const [startAnimation, setStartAnimation] = useState(false);
  const didRunGreetingFinish = useRef(false);

  useEffect(() => {
    const appbarElement = document.getElementById("appbar");
    if (appbarElement) {
      setAppbarHeight(appbarElement.offsetHeight);
    }
  }, []);

  useEffect(() => {
    const appbarElement = document.getElementById("appbar");
    if (appbarElement) {
      setAppbarHeight(appbarElement.offsetHeight);
    }
  }, [loading, showHeader]);

  useEffect(() => {
    if (smoothStatus !== "on" || !showHeader) return;
    let cancelled = false;
    let tries = 0;
    const tick = () => {
      if (cancelled) return;
      if (tref1.current) {
        setAnchorEl(tref1.current); // これで qrOpen=true になる
      } else if (tries < 40) {
        // 最大 ~2秒待つ
        tries += 1;
        setTimeout(tick, 50);
      }
    };
    tick();
    return () => {
      cancelled = true;
    };
  }, [smoothStatus, showHeader]);

  useEffect(() => {
    if (smoothLoaded && smoothStatus === "on") {
      runGreetingFinishOnce();
    }
  }, [smoothLoaded, smoothStatus]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await fetchSmoothReception(); // { id, status, updated_at }
        if (cancelled) return;
        setSmoothStatus(data?.status ?? "off");
      } catch (e) {
        console.error("fetchSmoothReception failed:", e);
        setSmoothStatus("off"); // 失敗時は安全側で off 扱い
      } finally {
        if (!cancelled) setSmoothLoaded(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    checkGuestExists();

    const socket = io(API_URL, {
      path: "/socket.io",
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 500,
      reconnectionDelayMax: 3000,
      timeout: 20000,
      query: {
        type: "INVITATION",
        id: id,
      },
    });

    socket.on("connect", () => console.info("socket connected", socket.id));
    socket.on("connect_error", (err) =>
      console.error("socket connect_error", err?.message, err)
    );
    socket.on("reconnect_attempt", (n) =>
      console.warn("socket reconnect_attempt", n)
    );
    socket.on("disconnect", (reason) =>
      console.warn("socket disconnect", reason)
    );

    loadPaymentLinks();

    socket.on("updatePaymentLinks", async () => {
      console.log("Received updatePaymentLinks event");
      const links = await fetchPaymentLinks();
      setPaymentLinks(links);
    });

    socket.on("guestIsAttend", (children) => {
      console.log("Guest Data:", children);

      setReceptedDialog(true);
      // const redirectUrl = `/guest/pamphlet/${id}`;
      // navigate(redirectUrl); // リダイレクト
    });

    return () => {
      socket.off("updatePaymentLinks");
      socket.disconnect();
    };
  }, [id, navigate]);

  const runGreetingFinishOnce = () => {
    if (didRunGreetingFinish.current) return;
    didRunGreetingFinish.current = true;
    handleGreetingFinish();
  };

  const checkGuestExists = async () => {
    try {
      const response = await fetchGuestById(id);
      if (!response.ok) {
        console.error("Guest not found, redirecting...");
        navigate("/guest/invalid");
      } else {
        const data = await response.json();
        // console.log([data])

        setLeader([data]);
        setGuests([data, ...data.invited_guests]);

        setShowHeader(false);
        if (data.will === "yes") {
          setShowHeader(true);
        }

        data.invited_guests.map(async (guest) => {
          if (guest.will === "yes") {
            setShowHeader(true);
          }
        });

        setLoading(false);
      }
    } catch (error) {
      navigate("/guest/invalid");
    }
  };

  const loadPaymentLinks = async () => {
    const links = await fetchPaymentLinks();
    setPaymentLinks(links);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    setGuests((prevGuests) => {
      const newGuests = [...prevGuests];
      newGuests[index] = { ...newGuests[index], [name]: value };
      return newGuests;
    });
  };

  const handleParticipation = async () => {
    setSendingLoading(true);
    console.log(guests);

    // 回答募集中かチェック
    const answer_availability = await fetchAnswerAvailability();
    if (answer_availability.status !== "open") {
      setSendingLoading(false);
      setDialogMessage("回答はすでに締切となっています。"); // エラーメッセージを設定
      setDialogOpen(true); // Dialogを開く
      return; // 処理を中断
    }

    // 参加・不参加の選択が必須であるかチェック
    const willValidation = guests.every(
      (guest) => guest.will === "yes" || guest.will === "no"
    );
    if (!willValidation) {
      setSendingLoading(false);
      setDialogMessage("全てのゲストに参加または不参加を選択してください。"); // エラーメッセージを設定
      setDialogOpen(true); // Dialogを開く
      return; // 処理を中断
    }

    // 名前とふりがなの入力チェック
    const nameValidation = guests.every(
      (guest) =>
        guest.last_name &&
        guest.first_name &&
        guest.last_furigana &&
        guest.first_furigana
    );
    if (!nameValidation) {
      setSendingLoading(false);
      setDialogMessage("全てのゲストの名前とふりがなを入力してください。"); // エラーメッセージを設定
      setDialogOpen(true); // Dialogを開く
      return; // 処理を中断
    }

    //SNSに投稿していいかのチェック
    const snsPermittionValidation = guests.every(
      (guest) => guest.sns_permission === "yes" || guest.sns_permission === "no"
    );
    if (!snsPermittionValidation) {
      setSendingLoading(false);
      setDialogMessage("全てのゲストにSNSの掲載許可を選択してください。"); // エラーメッセージを設定
      setDialogOpen(true); // Dialogを開く
      return; // 処理を中断
    }

    try {
      await sleep(600);
      const responses = await Promise.all(
        guests.map(async (guest) => {
          const guestData = { ...guest };
          if (!guestData.id) {
            delete guestData.id; // IDが空の場合は削除
          }
          return await invitationSubmit(guestData);
        })
      );

      const allSuccessful = responses.every(
        (response) => response.message === "success"
      );
      if (allSuccessful) {
        checkGuestExists();
        setDialogTitle("送信が完了しました。");
        setDialogMessage("送信が完了しました。");
        // setDialogMessage('当日、QRコードご提示いただくとスムーズです。ご希望の方は、ご祝儀のオンライン送金が可能です。'); // メッセージを設定

        setDialogOpen(true); // Dialogを開く
        setGuests([
          {
            first_name: "",
            first_furigana: "",
            last_name: "",
            last_furigana: "",
            gender: "M",
            allergy: "",
            will: "yet",
            invited_by: "",
          },
        ]); // 初期ゲストを追加
        // setSendComp(true)
      } else {
        setDialogMessage("送信に失敗しました。主催者にお伝えください。"); // エラーメッセージを設定
        setDialogTitle("送信に失敗しました。主催者にお伝えください。");
        setDialogOpen(true); // Dialogを開く
      }
    } catch (error) {
      console.log(error);
      setDialogMessage("エラーが発生しました。主催者にお伝えください。"); // エラーメッセージを設定
      setDialogTitle("エラーが発生しました。主催者にお伝えください。");
      setDialogOpen(true); // Dialogを開く
    } finally {
      setSendingLoading(false);
    }
  };

  const handleAddGuest = () => {
    if (guests.length >= 10) {
      setDialogMessage("招待できる人数は10人までです。"); // メッセージを設定
      setDialogOpen(true); // Dialogを開く
      return;
    }

    let arrangement_id = guests[0].arrangement_id;
    setGuests((prevGuests) => [
      ...prevGuests,
      {
        id: "",
        first_name: "",
        last_name: "",
        gender: "N",
        allergy: "",
        will: "yet",
        invited_by: id,
        arrangement_id: arrangement_id,
      },
    ]);
  };

  const handleRemoveGuest = (index) => {
    // setGuests(prevGuests => prevGuests.filter((_, i) => i !== index));
    setGuests((prevGuests) => {
      const newGuests = [...prevGuests];
      const guest = newGuests[index];

      if (guest.id) {
        // DBから取得したゲストの場合、削除フラグを立てる
        newGuests[index] = { ...guest, deleted_flag: 1 };
        console.log(newGuests[index]);

        try {
          invitationSubmit(newGuests[index]);
        } catch (error) {}
      } else {
        // 追加したばかりのゲストの場合、普通に削除
        newGuests.splice(index, 1);
      }

      console.log(newGuests);

      return newGuests;
    });
  };

  const handleCloseDialog = () => {
    // setSendComp(true)
    setDialogOpen(false); // Dialogを閉じる
    setTourOpen(true);
  };

  const handleCloseReceptedDialog = () => {
    // setSendComp(true)
    setReceptedDialog(false); // Dialogを閉じる
  };

  // if (sendingLoading) return <Sending />;

  const handleGreetingFinish = () => {
    setTimeout(() => {
      setStartAnimation(true);
    }, 200);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Container
        maxWidth="sm"
        sx={{
          // backgroundColor: '#f5f5f5', // 明るめのグレー
          // backgroundColor: 'white', // 白
          backgroundColor: "#fbf9f3",
          pb: 12, // 内側の余白
          pr: 0,
          pl: 0,
          borderRadius: 2, // 角を少し丸める
        }}
      >
        {showHeader ? (
          <Box maxWidth="sm">
            <GuestMenu
              leader={leader}
              children={guests}
              qrAnchorEl={anchorEl}
              setQrAnchorEl={setAnchorEl}
              qrOpen={open}
              sendComp={sendComp}
              setSendComp={setSendComp}
              paymentLinks={paymentLinks}
              id="appbar"
              tref1={tref1}
              tref2={tref2}
              tourOpen={tourOpen}
              setTourOpen={setTourOpen}
            ></GuestMenu>
            <Box sx={{ pb: 6 }} />
          </Box>
        ) : null}

        {smoothLoaded && smoothStatus !== "on" && (
          <Greeting onFinish={runGreetingFinishOnce} />
        )}

        <Stack spacing={4}>
          <Cover startAnimation={startAnimation} />

          <div id="introduction">
            <Introduction></Introduction>
          </div>

          <div id="our-story">
            <OurStory></OurStory>
          </div>

          <div id="personal-profile">
            <PersonalProfile></PersonalProfile>
          </div>

          <div id="information">
            <Information></Information>
          </div>

          <div id="invitation-form">
            <InvitationForm
              id="invitation-form"
              guests={guests}
              handleChange={handleChange}
              handleRemoveGuest={handleRemoveGuest}
              handleAddGuest={handleAddGuest}
              handleParticipation={handleParticipation}
              loading={buttonLoading}
            />
          </div>

          {/* <PaymentForm paymentLinks={paymentLinks}></PaymentForm> */}
        </Stack>

        <Box className="spacer-lg"></Box>
        <Box className="spacer-lg"></Box>

        {/* 送信完了のダイアログ */}
        <ThemeProvider theme={theme}>
          <Dialog
            open={dialogOpen}
            onClose={handleCloseDialog}
            sx={{
              zIndex: 2000, // 希望の z-index を設定
            }}
          >
            {/* <DialogTitle>結果</DialogTitle> */}
            <DialogContent
              sx={{
                fontFamily: "'KokuGothic', sans-serif",
                "& .MuiTypography-root": {
                  fontFamily: "'KokuGothic', sans-serif", // フォントを明示的に指定
                },
              }}
            >
              <DialogTitle textAlign="center">{dialogMessage}</DialogTitle>
              {/* <Typography >
                    当日、QRコードご提示いただくとスムーズです。
                </Typography>
                <Typography>
                    また、ご希望の方は、ご祝儀のオンライン送金が可能です。
                </Typography> */}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog} color="primary">
                閉じる
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>

        {/* 当日受付完了のダイアログ */}
        <ThemeProvider theme={theme}>
          <Dialog
            open={receptedDialog}
            onClose={handleCloseReceptedDialog}
            sx={{
              zIndex: 2000, // 希望の z-index を設定
            }}
          >
            {/* <DialogTitle>結果</DialogTitle> */}
            <DialogContent
              sx={{
                fontFamily: "'KokuGothic', sans-serif",
                "& .MuiTypography-root": {
                  fontFamily: "'KokuGothic', sans-serif", // フォントを明示的に指定
                },
              }}
            >
              <DialogTitle textAlign="center">受付が完了しました</DialogTitle>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseReceptedDialog} color="primary">
                閉じる
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </Container>

      {sendingLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 3000,
          }}
        >
          <Sending />
        </Box>
      )}
    </>
  );
};

export default Invitation;
